<template>
  <section class="activity">
    <section class="title_box" v-if="$store.state.common.theme!=3">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link tag="span" class="title_right" to="/emptyShopList">更多</router-link>
    </section>
    <section v-if="$store.state.common.theme==3" class="title_box_theme3">
      <h2 class="title_left">{{items.title}}</h2>
      <router-link tag="span" class="title_right" to="/emptyShopList">更多</router-link>
    </section>
    <template v-if="$store.state.common.theme!=3">
      <ul class="activity_list" v-if="items.listStyle == 0">
        <li @click="toDetail(item.id)" class="list_item" v-for="(item,index) in newList" :key="index">
          <div class="imgDiv">
            <img :src="item.smallUrl" alt>
          </div>
          <p>{{item.title}}</p>
          <span class="time">面积：{{item.jzmj}}㎡</span>
        </li>
      </ul>
      <ul class="activity_list_two" v-if="items.listStyle == 1">
        <li @click="toDetail(item.id)"
          class="list_item_t"
          v-for="(item,index) in newList"
          :key="index"
        >
          <div class="item_top">
            <div class="top_left">
              <img class="top_left_icon" src="../../../assets/images/empty_bg.jpg" />
              <img v-if="item.smallUrl" class="top_left_icon" :src="item.smallUrl" />
            </div>
            <div class="top_right">
              <p class="title">{{item.title}}</p>
              <p class="area">面积：{{item.jzmj}}㎡</p>
              <p class="adress over_two_lines">地址：{{item.address}}</p>
            </div>
          </div>
          <div class="item_bottom">
            <div class="bottom_left">
              <img class="bottom_left_icon" src="../../../assets/images/see.png" />
              <p class="bottom_left_text">{{item.viewNum}}人围观</p>
            </div>
            <div class="bottom_right">
              <p
                class="bottom_right_text"
                v-for="(cur,j) in item.label"
                :key="cur"
                v-if="j<2"
              ># {{cur}}</p>
            </div>
          </div>
        </li>
      </ul>
    </template>
    <template v-if="$store.state.common.theme==3">
      <div class="activity_list_theme3">
        <div @click="toDetail(item.id)" :class="index==2?'last_item':'list_item'" v-for="(item,index) in newList" :key="index">
          <img class="list_item_icon" :src="item.smallUrl" />
           <div class="list_item_title"><p >{{item.title}}</p></div> 
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import util from "../../../utils/util";
export default {
  name: "indexActivity",
  components: {},
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    items: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {};
  },
  filters: {
    time(val) {
      return util.formatTime(new Date(val), 6);
    }
  },
  computed: {
    newList () {
      let newList = this.list;
      if(this.$store.state.common.theme!=3){
        if (this.items.listStyle === 1) {
          return newList.slice(0, 2)
        } else {
          return newList.slice(0, 4)
        }
      }else{
        return newList.slice(0, 3)
      }
    }
  },
  methods: {
    toDetail(id){
      console.log(this.$store.state.common.userId)
      if(!this.$store.state.common.userId){
        this.$router.push({
          path:'/login',
          query:{
            Rurl:`/emptyShopDetail?id=${id}`
          }
        })
      }else{
        this.$router.push(`/emptyShopDetail?id=${id}`)
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.wrapper {
  width: 100%;
}
.activity {
  margin-top:10px;
  padding: .14rem 0.2rem 0;
  .title_box {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: 1rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size: 0.36rem;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .title_right {
      font-size: 0.26rem;
      color: #666;
    }
  }
  .title_box_theme3 {
    .flex();
    justify-content: space-between;
    align-items: center;
    height: .44rem;
    margin-bottom: 0.26rem;
    .title_left {
      .flex();
      flex-direction: row;
      font-size:40px;
      line-height: 44px;
      font-weight: bold;
      color: #000000;
      padding-right: 0.56rem;
      background: url("../../../assets/images/icon_hot_3.png") right center
        no-repeat;
      background-size: 44px 44px;
    }
    .title_right {
      font-size: 0.26rem;
      color: #c9a779;
    }
  }
}
.activity_list_two{
  margin-bottom:28px;
}
.activity_list {
  .flex();
  width: 100%;
  justify-content: space-between;
}
.activity_list_scroll {
  white-space: nowrap;
  width: 100%;
}
.activity_list {
  .flex();
  width: 100%;
  justify-content: space-between;
  .list_item {
    .flex();
    flex-direction: column;
    width: 344px;
    background-color: #FFFFFF;
    overflow: hidden;
    margin-bottom: 20px;
    .imgDiv{
      position: relative;
      width: 344px;
      height: 228px;
      background:url("../../../assets/images/empty_bg.jpg") left top no-repeat;
      background-size:344px 228px;
      img {
        display: block;
        width: 344px;
        height: 228px;
      }
      .status{
        position: absolute;
        display: flex;
        left: 0px;
        top: 180px;
        height:36px;
        background:rgba(255,70,10,1);
        border-radius:0px 18px 18px 0px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 2px;
        .fontSize(12px);
        color:rgba(255,255,255,1);
        line-height:32px;
        z-index: 1000;
      }

      .status_end{
        background:rgba(153,153,153,1);

      }

      .status_unstart{
        background:rgba(255,173,93,1);

      }

    }


    p {
      .fontSize(14px);
      font-weight: bold;
      color: @color3;
      line-height: 40px;
      margin-left: 10px;
      margin-top: 17px;
      .textOver(310px);
    }

    .time{
      width: 300px;
      margin-left: 10px;
      .fontSize(12px);
      color: @color9;
      line-height: 34px;
      margin-top:3px;
      .textOver(310px);
      margin-bottom:28px;
    }


  }
}
.item_top {
  margin-bottom: 28px;
  display: flex;
  flex-direction: row;
}

.item_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height:36px;
  align-items: center;
}

.bottom_left,
.bottom_right {
  display: flex;
  flex-direction: row;
}

.bottom_right {
  flex: 1;
  overflow: hidden;
  .flex();
  justify-content: flex-end;
}

.bottom_left_icon {
  height: 32px;
  width: 32px;
  margin-right: 14px;
}

.bottom_left_text {
  text-align: left;
  line-height: 32px;
  font-size: 24px;
  color: #999999;
}

.bottom_right_text {
  background-color: rgba(235, 239, 245, 1);
  border-radius: 4px;
  padding: 0 8px;
  font-size: 24px;
  color: rgba(60, 100, 159, 1);
  line-height: 36px;
  margin-right: 10px;
}

.top_left {
  position: relative;
  width: 240px;
  height: 180px;
  margin-right: 20px;
}
.top_right {
  flex: 1;
}

.top_left_icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 240px;
  height: 180px;
}

.title,
.area {
  text-align: left;
  color: #333333;
  line-height: 40px;
  font-size: 28px;
  margin-bottom: 10px;
  .textOver(400px);
}
.title {
  font-weight: bold;
}

.area {
  font-size: 24px;
  line-height: 28px;
  color: #999999;
}

.adress {
  text-align: left;
  color: #999999;
  line-height:34px;
  font-size: 24px;
  margin-bottom: 10px;
}
.list_item_t {
  background-color: rgba(255, 255, 255, 1);
  // border-radius: 8px;
  padding: 20px 0;
  .borderB();
  &:last-child {
    border:0;
  }
}

.activity_list_theme3{
  
  .flex();
  border-radius: 10px;
  flex-direction: row;
  background-color: #ffffff;
  padding-bottom: 20px;
  padding-top: 20px;
  .list_item{
    .flex();
    margin-right: 30px;
    margin-left: 10px;
    width: 200px;
    flex-direction: column;
   
  }
  .last_item{
    margin-right: 0;
    margin-left: 10px;
    .flex();
    width: 200px;
    flex-direction: column;
   
    
  }
  .list_item_icon{
    width: 200px;
    height: 200px;
  }
  .list_item_title{
    width: 200px;
    .flex();
    margin-top: 10px;
    flex-direction: row;
    justify-content: center;
    
    p{
        .fontSize(13px);
        font-weight: bold;
        color:#000000;
        line-height: 34px;
    
        .textOver(200px);
    }
  }

}
</style>
